import Modal from "@src/components/UIElements/Modal";

import UpcomingLiveCard from "@src/components/Tabs/Overview/components/UpcomingLive/UpcomingLiveCard/UpcomingLiveCard";
import { Image } from "@src/components/Image";
import React, { useEffect } from "react";
import { useRouter } from "@src/lib/router";
import { useDispatch, useSelector } from "react-redux";
import { getUpcomingClassesAction } from "./store/actions";
import { showUpcomingLiveClassesBottomSheetAction } from "../../store/actions";
import { useTranslation } from "react-i18next";
import { getAwsAssets } from "@src/utils";
import {
  getLiveCardDeepLink,
  getLiveCardIsAgora,
  getNewLiveCardStackType,
  LIVE_STACKTYPES,
} from "@src/utils/liveService/util";
import { selectNewLiveService } from "@root/store/selectors";
import 'intersection-observer';

const UpcomingClassModal = ({ className }) => {
  const { t } = useTranslation();
  // LIMIT
  let limit = 20;
  // ROUTER
  const router = useRouter();
  // DISPATCH
  const dispatch = useDispatch();

  const isPurchased = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.isPurchased
  );

  const fetchUpcomingClasses = (offset = 0) => {
    dispatch(
      getUpcomingClassesAction({
        isPurchased: isPurchased,
        courseId: router?.query?.courseId,
        limit: limit,
        offset: offset,
        facultyClasses: 0,
        currentList: upcomingClasses,
      })
    );
  };

  const fetchMore = () => {
    fetchUpcomingClasses(offset + limit);
  };

  const toggleModal = () => {
    dispatch(showUpcomingLiveClassesBottomSheetAction(false));
  };
  // SELECTORS
  const offset = useSelector(
    (state) => state?.upcomingClassesReducer?.upcomingClassOffset
  );
  const totalCount = useSelector(
    (state) => state?.upcomingClassesReducer?.upcomingClassTotalCount
  );
  const upcomingClasses = useSelector(
    (state) => state?.upcomingClassesReducer?.upcomingClassList
  );
  const loading = useSelector(
    (state) => state?.upcomingClassesReducer?.upcomingClassListLoading
  );
  const showModal = useSelector(
    (state) => state?.bottomSheetReducer?.showUpcomingLiveClassesBottomSheet
  );

  const useNewLiveService = useSelector(selectNewLiveService);

  // INFINITESCROLL
  const observer = React.useRef();

  const lastRowRef = React.useCallback(
    (element) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && offset + limit < totalCount) {
          fetchMore();
        }
      });
      if (element) observer.current.observe(element);
    },
    [offset < totalCount, fetchMore]
  );

  useEffect(() => {
    if (showModal) fetchUpcomingClasses();
  }, [showModal]);

  useEffect(() => {
    window.onLiveClassEnd = () => {
      fetchUpcomingClasses();
    };
  });

  return (
    <Modal
      handleClose={toggleModal}
      header={
        <div className={className}>
          <Image
            src={getAwsAssets("Vector2.svg", "liveClasses")}
            alt="upcomingClassIcon"
            width={24}
            height={24}
          />
          {t(
            "components.bottomSheets.components.upcomingLiveClassBottomSheet.upcomingLiveClasses",
            "Upcoming Live Classes"
          )}
        </div>
      }
    >
      <div className="UpcomingLiveModal">
        {upcomingClasses?.map((item, i) => {
          return (
            <div
              key={item?.id || i}
              className="UpcomingLiveModal__ListItem"
              {...(i === upcomingClasses?.length - 1 && fetchMore
                ? { ref: lastRowRef }
                : {})}
            >
              <UpcomingLiveCard
                upcomingClass={item}
                index={i}
                deeplink={getLiveCardDeepLink(item?.liveCard)}
                isAgora={
                  !useNewLiveService
                    ? getLiveCardIsAgora(item?.liveCard) ==
                      LIVE_STACKTYPES.AGORA
                    : getNewLiveCardStackType(item?.liveCard) === "agora"
                }
                emblem4={item?.emblem4}
              />
            </div>
          );
        })}
      </div>
    </Modal>
  );
};

export default UpcomingClassModal;
